import { type SyncCandidateStatusResponse } from "../api";
import { SyncStatus } from "./sync_status";

export interface CandidateSyncStatus extends SyncCandidateStatusResponse {}

export class CandidateSyncStatus extends SyncStatus<CandidateSyncStatus> {
  constructor(init?: Partial<SyncCandidateStatusResponse>) {
    super();
    Object.assign(this, init);
  }
}
